module.exports = __webpack_public_path__ + "static/media/shout.73b28c57.png";